import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
@Injectable()
export class EntrepotService {

    private api_url_get_all_entrepots = './api/server.php?cmd=GET_ENTREPOTS';
    private api_url_get_insert_entrepot = './api/server.php?cmd=INSERT_ENTREPOT';
    private api_url_get_update_entrepot = './api/server.php?cmd=UPDATE_ENTREPOT';
    private api_url_delete_entrepot = './api/server.php?cmd=REMOVE_ENTREPOT';

    constructor(private http: Http) {

    }

    GetEntrepots(): Promise<Object> {
        return this.http.get(this.api_url_get_all_entrepots)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    InsertEntrepot(location: any, reference: any): Promise<Object> {
        return this.http.get(this.api_url_get_insert_entrepot
            + '&location=' + location
            + '&reference=' + reference
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    UpdateEntrepot(id_location: any, location: any, reference: any, reference_old: any): Promise<Object> {
        return this.http.get(this.api_url_get_update_entrepot
            + '&id_location=' + id_location
            + '&location=' + location
            + '&reference=' + reference
            + '&reference_old=' + reference_old
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    DeleteEntrepot(location: any): Promise<Object> {
        return this.http.get(this.api_url_delete_entrepot
            + '&reference=' + location
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    //    location manager : début : 21-11-17


}



// WEBPACK FOOTER //
// ./src/app/entrepot.service.ts